/**
 * Directive: ruleBar
 */
angular.module('acme.common.directive.ruleBar', [
  'acme.common.service.helpers'
])
.directive('ruleBar', [function() {

    return {
      restrict: 'A',
      replace: true,
      templateUrl: 'common/directives/ruleBar/ruleBar.tpl.html',
      scope: {
        anchor: '@',
        anchoredValue: '=?',
        restrictions: '=',
        end: '=',
        start: '=',
        options: '=',
        conflicts: '=',
        allowExceedMaxRange: '=?'
      },
      
      link: function($scope, $element, $attrs) {
        // Modified after controller runs
        var win = $(window);

        $scope.$on('$destroy', function() {
          win.unbind('mousedown');
          win.unbind('mouseup');
        });

        $scope.ruleBarDraggable.init($element);

      },

      controller: ['$scope', '$timeout', 'HelpersService', function($scope, $timeout, HelpersService) {

        $scope.ruleBarDraggable = {

          handle: '',
          dragging: false,
          bar: {},
          element: {},
          width: 0,
          offset: 0,
          snap: true,
          win: $(window),
          moveTimer: false,
          resizeTimer: false,
          animate: true,
          leftPosition: 0,
          rightPosition: 0,

          init: function(ruleBar) {
            this.bar = $(ruleBar);
            this.width = this.bar.width();
            this.offset = this.bar.offset();
            $scope.$on('RuleBar::Update', this.onUpdate);
          },

          update: function() {
            var ruleBar = $scope.ruleBar;

            this.leftPosition = ruleBar.model.startPercent;
            this.rightPosition = (parseFloat(ruleBar.model.endPercent) + parseFloat(ruleBar.model.startPercent)) + '%';
          },

          setAnchoredValue: function() {

            var ruleBar = $scope.ruleBar;

            if (ruleBar.model.disableDragRight) {
              $scope.anchoredValue = $scope.end - $scope.start;
            }else if (ruleBar.model.disableDragLeft) {
              $scope.anchoredValue = $scope.end;
            }

          },

          start: function(e, handle) {
            e.preventDefault();

            this.handle = handle;
            this.x = e.clientX;

            this.win.bind('mousemove', function(e) {
              e.preventDefault();
              $scope.ruleBarDraggable.move(e.clientX);
            });

            this.win.bind('mouseup', function(e) {
              $scope.ruleBarDraggable.end();
              $scope.$apply();
            });

            this.win.bind('resize', function(e) {
              var self = $scope.ruleBarDraggable;

              if (this.resizeTimer) {
                $timeout.cancel(this.resizeTimer);
              }

              this.resizeTimer = $timeout(function() {
                self.width = self.bar.width();
                self.offset = self.bar.offset();
              }, 100);
            });

            this.dragging = true;
            this.animate = false;
          },

          end: function() {
            this.handle = '';
            $scope.end = $scope.ruleBar.model.endValue;
            $scope.start = $scope.ruleBar.model.startValue;
            this.setAnchoredValue();
            this.win.unbind('mousedown');
            this.win.unbind('mouseup');
            this.dragging = false;
            this.animate = true;
            $scope.ruleBar.update();
            $scope.$apply();
            $scope.$emit('RuleBar::DragUpdate');
          },

          move: function(x) {

            var ruleBar = $scope.ruleBar;

            if (this.dragging) {
              if (this.handle === 'left' ||
                this.handle === 'right') {
                this[this.handle](x);
                ruleBar.update();

                if (this.moveTimer) {
                  $timeout.cancel(this.moveTimer);
                }

                this.moveTimer = $timeout(function () {
                  $scope.end = ruleBar.model.endValue;
                  $scope.start = ruleBar.model.startValue;
                }, 10);

                $scope.$apply();
              }
            }

          },

          // Moves start of bar
          left: function(amount) {

            var value,
                ruleBar = $scope.ruleBar;

            if (amount > 0) {
              value = this.toScale(amount);
              if (value < ruleBar.model.endValue) {
                ruleBar.model.startValue = (value >= 0) ? value : 0;
                this.leftPosition = ruleBar.model.startPercent;
              }
            }

          },

          // Moves end of bar
          right: function(amount) {

            var value,
                ruleBar = $scope.ruleBar;

            if (amount > 0) {
              value = this.toScale(amount);
              if (value > ruleBar.model.startValue) {
                ruleBar.model.endValue = (value <= ruleBar.model.endRange) ? value : ruleBar.model.endRange;
                this.rightPosition = (parseFloat(ruleBar.model.endPercent) + parseFloat(ruleBar.model.startPercent)) + '%';
              }
            }

          },

          toScale: function(amount) {
            var ruleBar = $scope.ruleBar,
                pos = amount - this.offset.left,
                percent = (pos / this.width),
                scale = Math.round(percent * ruleBar.model.endRange);

            console.log(
              'RuleBar::ToScale',
              'Pos: ' + pos,
              'Left: ' + this.offset.left,
              'Width: ' + this.width,
              'Amount: ' + amount,
              'EndRange: ' + ruleBar.model.endRange,
              'Scale: ' + scale,
              'Percent: ' + percent);

            return scale;
          },

          onUpdate: function(e, data) {
            var self = $scope.ruleBarDraggable;

            self.width = self.bar.width();
            self.offset = self.bar.offset();

            self.update();
          }

        };

        $scope.ruleBar = {

          model: {
            draggable: true,
            alertRestriction: false,
            alertColor: '#d99531',
            restrictColor: '#000',
            activeColor: '#000',
            startValue: 0,
            endValue: 3,
            restrictions: [],
            startPercent: 0,
            endPercent: 0,
            startRange: 0,
            endRange: 100,
            startLabel: '0',
            endLabel: '100',
            anchoredStartLabel: '0',
            anchoredEndLabel: '100',
            units: 'months',
            allowExceedMaxRange: false
          },

          init: function() {
            if ($scope.options) {
              if ($scope.options.startLabel) {
                this.model.startLabel = $scope.options.startLabel;
              }
              if ($scope.options.endLabel) {
                this.model.endLabel = $scope.options.endLabel;
              }
              if ($scope.options.anchoredStartLabel) {
                this.model.anchoredStartLabel = $scope.options.anchoredStartLabel;
              }
              if ($scope.options.anchoredEndLabel) {
                this.model.anchoredEndLabel = $scope.options.anchoredEndLabel;
              }
              if ($scope.options.startLabelTemplate) {
                this.model.startLabelTemplate = $scope.options.startLabelTemplate;
              }
              if ($scope.options.endLabelTemplate) {
                this.model.endLabelTemplate = $scope.options.endLabelTemplate;
              }
              if ($scope.options.startRange) {
                this.model.startRange = $scope.options.startRange;
              }
              if ($scope.options.endRange) {
                this.model.endRange = $scope.options.endRange;
              }
              if ($scope.options.activeColor) {
                this.model.activeColor = $scope.options.activeColor;
                this.activeBarColor = this.model.activeColor;
              }
              if ($scope.options.alertColor) {
                this.model.alertColor = $scope.options.alertColor;
              }
              if ($scope.options.restrictColor) {
                this.model.restrictColor = $scope.options.restrictColor;
              }
              if ($scope.options.backgroundColor) {
                this.model.backgroundColor = $scope.options.backgroundColor;
              }
              if ($scope.options.disableDrag) {
                this.model.draggable = (!$scope.options.disableDrag);
              }

              // Anchor can be start, end, min, or max
              if ($scope.options.anchor) {
                this.model.anchor = $scope.options.anchor.toLowerCase();

                // Lock the dragability of the anchor point
                if ($scope.options.anchorLock) {
                  this.model.anchorLock = $scope.anchorLock;
                }
              }

              if ($scope.allowExceedMaxRange) {
                this.model.allowExceedMaxRange = $scope.allowExceedMaxRange;
              }

            }

            // Attr overrides options settings
            if ($scope.anchor) {
              this.model.anchor = $scope.anchor.toLowerCase();

              // Attr overrides options settings
              if ($scope.anchorLock) {
                this.model.anchorLock = $scope.anchorLock;
              }
            }

            this.setAnchorLock();


            $scope.$on('$destroy', $scope.$watch('start', this.onStartUpdate));
            $scope.$on('$destroy', $scope.$watch('end', this.onEndUpdate));
            $scope.$on('$destroy', $scope.$watch('options.disableDrag', this.onDisableDragUpdate));
            $scope.$on('$destroy', $scope.$watch('options.startLabel', this.onOptionsStartLabelUpdate));
            $scope.$on('$destroy', $scope.$watch('options.endRange', this.onOptionsEndRangeUpdate));
            $scope.$on('$destroy', $scope.$watch('options.endLabel', this.onOptionsEndLabelUpdate));
            $scope.$on('$destroy', $scope.$watchCollection('restrictions', this.onRestrictionsUpdate));
            $scope.$on('RuleBar::Update', this.onUpdate);

            this.updateEndLabelWithRange(this.model.endRange);
          },

          /**
           * Set internal value for draggability lock
           *
           */
          setAnchorLock: function() {
            this.model.disableDragLeft = (this.model.anchor && this.model.anchorLock && this.model.anchor === 'start' || this.model.anchor === 'min');
            this.model.disableDragRight = (this.model.anchor && this.model.anchorLock && this.model.anchor === 'end' || this.model.anchor === 'max');
          },

          /**
           * Will return the anchored percent based on settings
           *
           * @param value {number}
           * @param position {String} start,end,min,max
           * @returns {number}
           */
          getAnchoredValue: function(value, position) {
            var r = value;

            // Account for either min or start anchors
            if (position === 'start') {
              if (this.model.anchor === 'min') {
                r = this.model.startRange;
              }else if (this.model.anchor === 'start') {
                r = this.model.startValue;
              }
            }else if (position === 'end') {
              if (this.model.anchor === 'max') {
                r = this.model.endRange;
              }else if (this.model.anchor === 'end') {
                r = this.model.endValue;
              }
            }

            return r;
          },

          getStartPercent: function(number, startRange, endRange) {

            var percentRange = endRange - startRange,
                percent = number / percentRange;

            if (percent > percentRange) {
              percent = 100;
            }

            return (percent * 100) + '%';

          },

          getEndPercent: function(number, startPercent, startRange, endRange) {

            var percentRange = endRange - startRange,
                percent = number / percentRange;

            if (percent > percentRange) {
              percent = 100;
            }

            return ((percent * 100) - parseFloat(startPercent)) + '%'; // Account for width instead of actual end percentage

          },

          checkRestrictions: function() {

            var i, ii,
                alert = false,
                restrictEndPercent,
                restrictStartPercent,
                startPercent = parseFloat(this.model.startPercent),
                endPercent = startPercent + parseFloat(this.model.endPercent); // Reconcile width subtraction

            for (i=0,ii=this.model.restrictions.length;i<ii;i++) {

              restrictStartPercent = parseFloat(this.model.restrictions[i].startPercent);
              restrictEndPercent = restrictStartPercent + parseFloat(this.model.restrictions[i].endPercent); // Reconcile width subtraction

              if (startPercent < restrictEndPercent) {
                if (endPercent > restrictStartPercent) {
                  alert = true;
                  break;
                }
              }

            }

            $scope.conflicts = this.model.alertRestriction = alert;
            this.activeBarColor = (this.model.alertRestriction) ? this.model.alertColor : this.model.activeColor;

          },

          updateRestrictStart: function(number) {
            this.model.restrictStartPercent = this.getStartPercent(number, this.model.startRange, this.model.endRange);
          },

          updateRestrictEnd: function(number) {
            this.model.restrictEndPercent = this.getEndPercent(number, this.model.restrictStartPercent, this.model.startRange, this.model.endRange);
          },

          updateStart: function(number) {

            var start = this.getStartPercent(number, this.model.startRange, this.model.endRange);

            if (number < this.model.endValue &&
                parseInt(start, 10) <= 100 &&
                parseInt(start, 10) >= 0) {
              this.model.startPercent = start;
            }

          },

          updateEnd: function(number) {

            var end = this.getEndPercent(number, this.model.startPercent, this.model.startRange, this.model.endRange);

            if (number > this.model.startValue &&
                parseInt(end, 10) <= 100 &&
                parseInt(end, 10) >= 0) {
              this.model.endPercent = end;
            }

          },

          updateEndLabelWithRange: function(range) {
            if (range === 999) {
              this.model.endLabel = 'Perpetual';
            }else{
              if (this.model.endLabelTemplate) {
                this.model.endLabel = this.model.endLabelTemplate.replace('%s', this.model.endRange + ' ' + HelpersService.cap(this.model.units));
              }else {
                this.model.endLabel = this.model.endRange + ' ' + HelpersService.cap(this.model.units);
              }
            }
          },

          update: function() {
            this.updateStart(this.model.startValue);
            this.updateEnd(this.model.endValue);
            this.checkRestrictions();
          },

          onUpdate: function(e, data) {
            var self = $scope.ruleBar;
            self.update();
          },

          onRestrictionsUpdate: function(n, o) {

            var i, ii,
                startPercent,
                endPercent,
                self = $scope.ruleBar;

            if (n instanceof Array) {
              self.model.restrictions = [];

              for (i = 0, ii = n.length; i < ii; i++) {
                startPercent = self.getStartPercent(n[i].start, self.model.startRange, self.model.endRange);
                endPercent = self.getEndPercent(n[i].end, startPercent, self.model.startRange, self.model.endRange);

                self.model.restrictions.push({
                  startPercent: startPercent,
                  endPercent: endPercent
                });
              }
            }

          },

          onEndUpdate: function(n, o) {
            var self = $scope.ruleBar;

            if (n !== o) {
              if (self.model.endRange < n) {
                if (self.model.allowExceedMaxRange && n !== 999) {
                  self.model.endRange = n;
                }
                self.model.endValue = self.model.endRange;
              } else {
                self.model.endValue = n;
              }

              self.updateEndLabelWithRange(n);

            }

          },

          onStartUpdate: function(n, o) {
            var self = $scope.ruleBar;

            if (n !== o) {
              self.model.startValue = n;
            }
          },

          onOptionsStartLabelUpdate: function(n, o) {
            var self = $scope.ruleBar;

            if (n !== o) {
              self.model.startLabel = n;
            }
          },

          onOptionsEndLabelUpdate: function(n, o) {
            var self = $scope.ruleBar;

            if (n !== o) {
              if (self.model.endValue === 999) {
                self.model.endLabel = self.model.endLabel || 'Perpetual';
              }else {
                self.model.endLabel = n;
              }
            }
          },

          onOptionsEndRangeUpdate: function(n, o) {
            var self = $scope.ruleBar;

            if (n !== o) {
              self.model.endRange = n;
              if (self.model.endRange < self.model.endValue) {
                if (!self.model.allowExceedMaxRange) {
                  self.model.endValue = self.model.endRange;
                }
              }
              self.updateEndLabelWithRange(n);
            }
          },

          onDisableDragUpdate: function(n, o) {
            var self = $scope.ruleBar;

            self.model.draggable = (!n);
          }

        };

        $scope.ruleBar.init();

      }]

    };

}]);